var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useState, useRef } from "react";
import Flex from "../../../components/templates/flex";
var Tabs = function (_a) {
    var children = _a.children;
    var _b = useState(false), collapsed = _b[0], setCollapsed = _b[1];
    var ref = useRef();
    var tabs = useMemo(function () {
        return React.Children.map(children, function (child) {
            var draggable = child.type.displayName === "DraggableTabs";
            return React.cloneElement(child, __assign({ collapsed: collapsed }, (draggable && { onResize: setCollapsed, ref: ref })));
        });
    }, [collapsed, children]);
    return (React.createElement(Flex, { column: true, width: "100%", position: "relative", ref: ref },
        React.createElement(Flex, { height: "1px", background: "borderSecondary", width: "100%", position: "absolute", style: { top: 0 }, zIndex: 3 }),
        React.createElement(Flex, { justifyContent: "start", alignSelf: "start", alignItems: "end", width: "100%", height: "100%", overflow: "hidden", background: "elementBackground" }, tabs),
        React.createElement(Flex, { height: "1px", background: "borderSecondary", width: "100%", position: "absolute", style: { bottom: 0 }, zIndex: 1 })));
};
export default Tabs;
